import React, { useState } from "react";
import { Box, Divider, Typography, Button } from "@material-ui/core";
import { IntroText, ButtonLoader } from "../../../components";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { ROUTE_PATHS } from "../../../constants";

const ScheduleSymptomsVax = ({ updateScheduleData }) => {
  const history = useHistory();
  const { t } = useTranslation();
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  const handleChange = symptomsVax => {
    updateScheduleData({ symptomsVax });
  };

  return (
    <Box data-cy="schedule-screen-symptoms-vax">
      {!showDisclaimer ? (
        <>
          <IntroText>{t("schedule.symptoms_vax.intro_text")}</IntroText>
          <ButtonLoader
            variant="contained"
            color="primary"
            fullWidth
            size="large"
            data-cy="symptoms-vax-no"
            onClick={e => handleChange(false)}
          >
            {t("schedule.symptoms_vax.options.no")}
          </ButtonLoader>
          <Box my={2}>
            <Divider variant="middle" />
          </Box>
          <ButtonLoader
            variant="contained"
            fullWidth
            size="large"
            data-cy="symptoms-vax-yes"
            onClick={e => setShowDisclaimer(true)}
          >
            {t("schedule.symptoms_vax.options.yes")}
          </ButtonLoader>
        </>
      ) : (
        <>
          <IntroText>
            {t("schedule.symptoms_vax.disclaimer.intro_text")}
          </IntroText>
          <Typography paragraph>
            {t("schedule.symptoms_vax.disclaimer.secondary_text")}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            size="large"
            fullWidth
            onClick={() =>
              history.push({ pathname: ROUTE_PATHS.GGT.SCHEDULE_START })
            }
          >
            {t("schedule.symptoms_vax.disclaimer.button")}
          </Button>
          <Box mt={2}>
            <Button
              variant="contained"
              size="large"
              fullWidth
              onClick={() => setShowDisclaimer(false)}
            >
              {t("schedule.symptoms_vax.disclaimer.button_secondary")}
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
};

export { ScheduleSymptomsVax };
